/**
 * Transformer that is triggered when the user goes to initial page. It cancels all
 * completed flows because the user starts over.
 */
export default (kasko) => {
  kasko.addEventListener('route-changed', ({ current }) => {
    if (current && current.path === 'initial') {
      kasko.dispatchEvent('set-state-input', {
        item_A: false,
        item_B: false,
        item_C: false,
        item_A_B: false,
        item_A_C: false,
        item_B_C: false,
        item_A_B_C: false,
      });
    }
  });
};
